<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t("invoices.funder.sendToFunder") }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/dashboard">{{
            $t("general.home")
          }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            v-if="$route.name === 'preapproved-invoice-sendFunder'"
            slot="item-title"
            to="/super-admin/preapproved-invoices"
            >{{ $tc("preapproved_invoices.invoice", 2) }}</router-link
          >
          <router-link v-else slot="item-title" to="/super-admin/invoices">{{
            $tc("invoices.invoice", 2)
          }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">{{
            $tc("invoices.funder.sendToFunder")
          }}</router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div class="col-xs-2 mr-4">
          <base-button
            size="large"
            icon="times"
            :outline="true"
            color="theme"
            @click="rejectedPrepaymentRequest()"
            :loading="isLoading"
            v-if="
              invoice_request_level == 'Approved' && userType == 'super_admin'
            "
          >
            {{ $t("general.reject") }}
          </base-button>
        </div>
        <div class="col-xs-2" v-show="showEmptyScreen">
          <base-button
            size="large"
            icon="plus"
            color="theme"
            @click="addFunder"
          >
            {{ $t("invoices.funder.newFunder") }}
          </base-button>
        </div>
      </div>
    </div>
    <SingleInvoiceRow :fetchData="fetchInvoiceData" />
    <SinglePrepaymentRequestRow :prepaymentRequest="prepaymentRequest" />
    <div
      v-cloak
      v-show="showEmptyScreen"
      class="col-xs-1 no-data-info"
      align="center"
    >
      <astronaut-icon class="mt-5 mb-4" />
      <div class="row" align="center">
        <label class="col title">{{ $t("accounts.no_accounts") }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{
          $t("accounts.list_of_accounts")
        }}</label>
      </div>
      <div class="btn-container">
        <base-button
          :outline="true"
          color="theme"
          class="mt-3"
          size="large"
          @click="addFunder"
        >
          {{ $t("invoices.funder.newFunder") }}
        </base-button>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">
          {{ $t("general.showing") }}: <b>{{ funderAccounts.length }}</b>
          {{ $t("general.of") }} <b>{{ totalFunderAccounts }}</b>
        </p>

        <transition name="fade" v-if="sendFundersDisable == false">
          <v-dropdown v-if="selectedFunderAccount > 0" :show-arrow="false">
            <span
              slot="activator"
              href="#"
              class="table-actions-button dropdown-toggle"
            >
              {{ $t("general.actions") }}
            </span>
            <v-dropdown-item>
              <div class="dropdown-item" @click="invoiceSendtoFunder">
                <font-awesome-icon
                  icon="paper-plane"
                  class="dropdown-item-icon"
                />
                {{ $t("invoices.funder.sendToFunder") }}
              </div>
            </v-dropdown-item>
          </v-dropdown>
        </transition>
      </div>

      <div class="custom-control"></div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="fetchData"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-radio">
              <input
                :disabled="sendFundersDisable"
                :id="row.id"
                v-model="selectFunderField"
                :value="row.id"
                type="radio"
                class="custom-control-input"
              />
              <label :for="row.id" class="custom-control-label" />
            </div>
          </template>
        </table-column>

        <table-column
          :label="$t('accounts.company_name')"
          show="company_name"
        />
        <table-column :label="$t('accounts.phone')" show="phone" />

        <table-column
          :label="$t('accounts.added_on')"
          sort-as="created_at"
          show="formattedCreatedAt"
        />

        <table-column
          :label="$t('accounts.status')"
          sort-as="status"
          show="UpperCaseStatus"
        />
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import DotIcon from "../../components/icon/DotIcon";
import AstronautIcon from "../../components/icon/AstronautIcon";
import BaseButton from "../../../js/components/base/BaseButton";
import { request } from "http";
import SingleInvoiceRow from "./SingleInvoiceRow";
import SinglePrepaymentRequestRow from "../prepayments/SinglePrepaymentRequestRow.vue";
export default {
  components: {
    DotIcon,
    AstronautIcon,
    SweetModal,
    SweetModalTab,
    BaseButton,
    SingleInvoiceRow,
    SinglePrepaymentRequestRow
  },
  data() {
    return {
      sendFundersDisable: false,
      sendFunders: [],
      userAccounts: [],
      showFilters: false,
      isLoading: false,
      filtersApplied: false,
      tableDivId: "tableDivId",
      account_types: [],
      advanceOption: true,
      isRequestOngoing: true,
      invoice_request_level: null,
      userType: "",
      fetchInvoiceData: [],
      prepaymentRequest: [],
      filters: {
        display_name: "",
        company_name: "",
        phone: "",
        role: "",
        status: "",
        account_type: ""
      }
    };
  },
  computed: {
    showEmptyScreen() {
      return !this.totalFunderAccounts && !this.isRequestOngoing;
    },
    filterIcon() {
      return this.showFilters ? "times" : "filter";
    },
    ...mapGetters("account", [
      "accounts",
      "selectedAccounts",
      "selectedFunderAccount",
      "totalAccounts",
      "selectAllField",
      "funderAccounts",
      "totalFunderAccounts",
      "selectAllFunderField"
    ]),
    selectFunderField: {
      get: function() {
        return this.selectedFunderAccount;
      },
      set: function(val) {
        this.selectFunderAccount(val);
      }
    },
    selectAllFieldStatus: {
      get: function() {
        return this.selectAllFunderField;
      },
      set: function(val) {
        this.setSelectAllFunderState(val);
      }
    }
  },
  watch: {
    filters: {
      handler: "setFilters",
      deep: true
    }
  },
  destroyed() {
    if (this.selectedFunderAccount) {
      this.selectAllFunderAccount();
    }
  },
  created() {
    if (
      localStorage.getItem("role") == "super_admin" ||
      localStorage.getItem("account_type") == "anchor"
    ) {
      this.advanceOption = false;
    } else {
      this.advanceOption = true;
    }
    if (localStorage.getItem("role") == "super_admin") {
      this.userType = "super_admin";
    } else if (localStorage.getItem("account_type") == "anchor") {
      this.userType = "anchor";
    } else if (localStorage.getItem("account_type") == "supplier") {
      this.userType = "supplier";
    }
    this.loadInvoice();
    this.setInvoiceData();
    this.loadRequest();
  },
  methods: {
    ...mapActions("invoice", [
      "SingleInvoiceArray",
      "fetchInvoice",
      "fetchInvoiceShow"
    ]),
    ...mapActions("account", [
      "fetchAccounts",
      "selectAllFunderAccount",
      "selectAccount",
      "selectFunderAccount",
      "deleteAccount",
      "deleteMultipleAccounts",
      "setSelectAllState",
      "fetchFunderAccounts",
      "invoiceSendtoFunderAccounts",
      "setSelectAllFunderState"
    ]),
    ...mapActions("LoanRequest", ["loanRequestStatus"]),
    ...mapActions("prepayment", ["fetchPrePaymentRequest", "fetchPrePayment"]),
    async addFunder() {
      this.$router.push(`/super-admin/accounts/create`);
    },
    async loadInvoice() {
      let response = await this.SingleInvoiceArray(this.$route.params.id);
      if (response.data) {
        this.fetchInvoiceData = response.data.invoice;
        this.sendFunders = response.data.funder_invoices;
        if (this.sendFunders) {
          this.sendFundersDisable = true;
        }
      }
    },
    async loadRequest() {
      if (this.$route.params.id) {
        let res = await this.fetchPrePaymentRequest(this.$route.params.id);
        if (res.data) {
          this.prepaymentRequest = res.data.prepaymentRequest;
        }
      }
    },

    refreshTable() {
      this.$refs.table.refresh();
    },
    async fetchData({ page, per_page, filter, sort }) {
      let data = {
        role: "admin",
        account_type: "funder",
        orderByField: sort.fieldName || "users.created_at",
        orderBy: sort.order || "desc",
        status: "active",
        per_page, // Add rowsPerPage in the API request
        page
      };
      this.isRequestOngoing = true;

      let response = await this.fetchFunderAccounts(data);
      this.isRequestOngoing = false;
      this.account_types = response.data.account_types;
      this.userAccounts = response.data.accounts.data;
      return {
        data: this.userAccounts,
        pagination: {
          totalPages: response.data.accounts.last_page,
          currentPage: page,
          rowsPerPage: response.data.accounts.per_page // Add rowsPerPage in the API request
        }
      };
    },
    setFilters() {
      this.filtersApplied = true;
      this.refreshTable();
    },
    async invoiceSendtoFunder() {
      let data = {
        invoiceId: this.$route.params.id,
        userId: this.selectedFunderAccount
      };
      this.isRequestOngoing = true;
      this.sendFundersDisable = true;
      this.isLoading = true;
      let response = await this.invoiceSendtoFunderAccounts(data);
      this.isRequestOngoing = false;
      this.isLoading = false;
      if (response.data.success) {
        if (this.$route.name === "preapproved-invoice-sendFunder") {
          this.$router.push("/super-admin/preapproved-invoices");
        } else {
          this.$router.push("/super-admin/invoices");
        }

        window.toastr["success"](
          this.$tc("invoices.funder.invoice_send_message")
        );
      }
    },
    async rejectedPrepaymentRequest() {
      const data = {
        invoice_id: this.$route.params.id,
        request_level: "Rejected"
      };
      this.isLoading = true;
      let response = await this.loanRequestStatus(data);
      if (response.data.success) {
        if (this.userType == "super_admin") {
          if (this.$route.name === "preapproved-invoice-sendFunder") {
            this.$router.push("/super-admin/preapproved-invoices");
          } else {
            this.$router.push("/super-admin/invoices");
          }
        }
        this.isLoading = false;
        window.toastr["success"](
          this.$tc("prepayments.prepayment_rejected_message")
        );
        return true;
      }
    },
    async setInvoiceData() {
      let data = await this.fetchInvoiceShow(this.$route.params.id);
      this.invoice_request_level = data.data.invoice.request_level;
    }
  }
};
</script>
<style scoped>
#tableDivId {
  min-height: 0px;
}
</style>
